import React, { useContext, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';

import { IonPage, isPlatform } from '@ionic/react';

import { Auth } from '../services/AuthService';

import { AppContext } from '../state/AppContextProvider';

import AppDownloadsLinks from '../components/landing/AppDownloadsLinks';
import { LogoHeader } from '../components/landing/LogoHeader';

interface LandingPageProps extends RouteComponentProps {}

const Landing: React.FC<LandingPageProps> = (props: LandingPageProps) => {
  const { state } = useContext(AppContext);

  const [loading, setLoading] = useState(false);

  const isWeb = !isPlatform('capacitor');

  function handleSignIn(e: any) {
    setLoading(true);
    e.preventDefault();
    Auth.signIn().finally(() => {
      setLoading(false);
    });
  }

  return state.isAuthLoaded && state.isConnected ? (
    <Redirect to={state.requestedPath} />
  ) : (
    <IonPage>
      <div className="w-full h-full items-center">
        <LogoHeader />
        <div className="grid grid-flow-row gap-y-5 md:gap-y-10 py-5 md:py-10 text-center justify-center bg-white h-4/5 xl:h-3/5 px-6">
          <div className="flex flex-col-reverse justify-center">
            <div>
              <h2 className="text-xl font-bold mb-2 leading-6">
                Bienvenue sur le Portail des résidents CiuP
              </h2>
              <p className="text-sm text-gray-500">
                Connectez-vous pour accéder à de nombreux services et profiter
                de la vie du campus.
              </p>
              <p className="text-sm text-gray-500">
                Besoin d'aide ? L'équipe de l'application vous accompagne :{' '}
                <a className="font-bold" href="mailto:support@ciup.help">
                  support@ciup.help
                </a>
              </p>
            </div>
          </div>
          <div className="flex flex-col-reverse justify-center">
            <div>
              <h2 className="text-xl font-bold leading-6 italic text-primary">
                Welcome to the CiuP residents Portal
              </h2>
              <p className="text-sm text-primary text-opacity-80 italic">
                Log in to access many services and enjoy campus life.
              </p>
              <p className="text-sm text-primary text-opacity-80 italic">
                Need help? The application team will help you :{' '}
                <a className="font-bold" href="mailto:support@ciup.help">
                  support@ciup.help
                </a>
              </p>
            </div>
          </div>
          <div className="place-self-center grid grid-rows-2">
            <div className="grid items-center">
              <button
                type="button"
                className={`inline-flex items-center justify-center px-6 py-4 w-full border border-transparent shadow-sm font-bold rounded-3xl text-sm text-white text-center hover:bg-opacity-75 focus:outline-none curs ${
                  loading
                    ? 'bg-lightGrey cursor-not-allowed hover:bg-lightGrey '
                    : 'bg-primary hover:bg-primary '
                }`}
                onClick={handleSignIn}
              >
                Connexion / Login
              </button>
            </div>
            {isWeb && (
              <div className="place-self-center">
                <AppDownloadsLinks />
              </div>
            )}
          </div>
        </div>
      </div>
    </IonPage>
  );
};

export default Landing;
